(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prod-d"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================
   NEW ARRIVALS LUXE  |  assets/section-new-arrivals-luxe.js
   1) <nal-product-form>  AJAX add to cart (works with Dawn's
      cart drawer / cart notification / cart page)
   2) <nal-slider>        arrows for the desktop slider mode
   No libraries needed.
   ========================================================== */

/* ---------- 1. ADD TO CART ---------- */
if (!customElements.get('nal-product-form')) {
  class NalProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      this.errorEl = this.querySelector('.nal-form__error');
      if (!this.form || !this.button) return;

      this.onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.button.getAttribute('aria-disabled') === 'true' || this.button.disabled) return;

      this.setLoading(true);
      this.showError('');

      /* Dawn's cart element (drawer or notification popup) */
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      const formData = new FormData(this.form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id).join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      /* Use Dawn's helper when it exists, otherwise a plain config */
      const config =
        typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';

      try {
        const response = await fetch(addUrl, config);
        const state = await response.json();

        /* Shopify returns { status, message, description } on error */
        if (state.status) {
          this.showError(state.description || state.message || 'Could not add this item.');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'nal-product-form',
              productVariantId: formData.get('id'),
              errors: state.errors || state.description,
              message: state.message,
            });
          }
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'nal-product-form',
            productVariantId: formData.get('id'),
            cartData: state,
          });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(state);
        } else {
          /* Theme uses the cart page: send the shopper there */
          window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        }
      } catch (error) {
        console.error('[New Arrivals Luxe] add to cart failed:', error);
        this.showError('Something went wrong. Please try again.');
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(isLoading) {
      this.button.classList.toggle('is-loading', isLoading);
      if (isLoading) {
        this.button.setAttribute('aria-disabled', 'true');
      } else {
        this.button.removeAttribute('aria-disabled');
      }
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = !message;
    }
  }

  customElements.define('nal-product-form', NalProductForm);
}

/* ---------- 2. DESKTOP SLIDER ARROWS ---------- */
if (!customElements.get('nal-slider')) {
  class NalSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-nal-track]');
      this.prev = this.querySelector('[data-nal-prev]');
      this.next = this.querySelector('[data-nal-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.update = this.update.bind(this);
      this.onPrev = () => this.scrollByCard(-1);
      this.onNext = () => this.scrollByCard(1);

      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
    }

    scrollByCard(direction) {
      const item = this.track.querySelector('.nal-item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const scrollable = maxScroll > 4;

      this.prev.hidden = !scrollable;
      this.next.hidden = !scrollable;
      if (!scrollable) return;

      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
    }
  }

  customElements.define('nal-slider', NalSlider);
}

  } catch(e) { console.error(e); }
})();
})();
